import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row } from "@atom/ui-kit";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import Title from "antd/es/typography/Title";
var PlayerManagementFilterSpace = function (_a) {
    var onSearch = _a.onSearch;
    var form = Form.useForm()[0];
    var t = useTranslation().t;
    var handleSearch = function (values) {
        if (onSearch)
            onSearch(values);
    };
    var handleFieldChange = debounce(function (changedFields) {
        var _a;
        var changedField = changedFields[0];
        if (changedField) {
            form.setFieldsValue({
                type: changedField.name[0] === "type" ? form.getFieldValue("type") : undefined,
                playerId: changedField.name[0] === "playerId" ? form.getFieldValue("playerId") : undefined,
                playerName: changedField.name[0] === "playerName" ? form.getFieldValue("playerName") : undefined,
                lobbyId: changedField.name[0] === "lobbyId" ? form.getFieldValue("lobbyId") : undefined,
                currency: changedField.name[0] === "currency" ? form.getFieldValue("currency") : undefined,
            });
            onSearch === null || onSearch === void 0 ? void 0 : onSearch((_a = {},
                _a[changedField.name[0]] = changedField.value,
                _a));
        }
    }, 500);
    return (_jsx(Form, { form: form, layout: "inline", onFinish: handleSearch, onFieldsChange: handleFieldChange, style: { width: "100%", justifyContent: "space-between" }, children: _jsxs(Col, { children: [_jsx(Title, { style: {
                        color: "#262338",
                        fontSize: "15px",
                        fontWeight: "600",
                        lineHeight: "20px",
                        letterSpacing: "0.75px",
                    }, level: 5, children: t("playerManagement.filters.title") }), _jsxs(Row, { style: { width: "100%" }, justify: "space-between", children: [_jsx(Col, { xs: 18, children: _jsx(Form.Item, { name: "playerName", children: _jsx(Input, { size: "small", variant: "borderless", placeholder: t("playerManagement.filters.searchWithPlayerName") }) }) }), _jsx(Col, { xs: 6, children: _jsx(Button, { buttonType: "primary", buttonSize: "small", icon: _jsx(SearchOutlined, {}), htmlType: "submit", children: t("playerManagement.filters.search") }) })] })] }) }));
};
export default PlayerManagementFilterSpace;
